import Footer from "../../Shared/Components/Footer";
import {useEffect} from "react";
import {scrollToTop} from "../../Shared/Util/Functions";

export interface SafetyWelcomeProps {
    onOpen: () => void
    onCancel: () => void
}

export default function SafetyWelcome(props: SafetyWelcomeProps) {

    useEffect(() => {
        scrollToTop()
    }, [])

    return <div className="welcome safety" style={{backgroundImage: "url('images/safety/welcome-background.png')"}}>
        <div className="text">
            <p><span className="dark-blue">Witaj</span>  w naszej zagadkowej przygodzie! Znajdziesz tu ważne informacje dotyczące bezpieczeństwa podczas górskich wycieczek, wypoczynku nad wodą czy uprawiania narciarstwa. Mamy nadzieję, że dzięki naszej zabawie uda Ci się wszystko zapamiętać i w razie wypadku będziesz potrafił odpowiednio się zachować i udzielić pomocy potrzebującym.</p>

            <p>Na początek chcielibyśmy Ci przypomnieć o bardzo ważnej sprawie – numerze telefonu ratunkowego w górach 985 oraz 112. Gdy będziesz świadkiem wypadku, zadzwoń pod ten numer i opowiedz o tym, co się wydarzyło. Osoba, która odbierze telefon, zada Ci kilka ważnych pytań dotyczących miejsca zdarzenia i liczby poszkodowanych osób. Musisz być na to przygotowany, ale jesteśmy pewni, że sobie poradzisz!</p>

            <p>Gdy idziesz na wycieczkę w góry, zainstaluj w telefonie aplikację <span className="light-blue">Ratunek</span>, która w razie potrzeby przekaże ratownikom informacje o tym, gdzie dokładnie jesteś. Powiedz o tej aplikacji również swoim bliskim.</p>

            <p>A teraz zaczynamy zabawę!</p>

            <button className="btn green" onClick={() => props.onOpen()}>Dalej</button>
        </div>
        <img className="helper" src="images/safety/helper-welcome.png" alt="helper" />
        <img className="phone" src="images/safety/phone.png" alt="phone" />
        <Footer home={props.onCancel}/>
    </div>

}